module.exports = __webpack_public_path__ + "static/vivaldy-skin-clinic-logo-c9305283ddb3b78428afaa0bc263e1b9.png";